<template>
<v-dialog id="onboarding-container" class="border-radius-15" origin="center center" v-model="open" persistent attach="#root" content-class="onboarding-dialog-active" hide-overlay>
  <v-stepper dark class="white--text prestige" id="onboarding-stepper" v-model="onboardingStep" vertical>
    <v-flex text-xs-center>
      <p class="pt-2 headline bebas ">Setup Instructions</p>
      <p class="mx-4 subheading prestige ">The Food Done It Web Application performs best when downloaded to the homescreen.<br><br>Please follow the below instructions</p>
    </v-flex>
    <v-stepper-step class="prestige" color="red" :complete="onboardingStep > 2" step="1" :editable="onboardingStep > 2">Download To Home Screen</v-stepper-step>

    <v-stepper-content step="2">
      <v-container v-if="onIphone" pa-0>
        <v-card class="mb-5 border-radius-15">
          <v-stepper dark v-model="e6" vertical>
            <v-stepper-step color="red" :complete="e6 > 1" step="1" :editable="e6 > 1">
              Press the Share Button
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-flex d-flex text-xs-center>
                <v-flex>

                  <v-img :src="shareButtonFull" />
                </v-flex>
              </v-flex>
              <v-flex d-flex text-xs-center my-3 justify-center align-center>
                <v-flex xs8>
                  <v-btn class="bebas" small flat outline color="white" @click="e6 = 2">Got it</v-btn>
                </v-flex>
              </v-flex>

            </v-stepper-content>

            <v-stepper-step color="red" :complete="e6 > 2" step="2" :editable="e6 > 2">Add To Home Screen Button</v-stepper-step>

            <v-stepper-content step="2">
              <v-flex class="border-radius-5" d-flex text-xs-center>
                <v-card>

                  <v-img :src="shareMenuFull" />
                </v-card>
              </v-flex>
              <v-flex d-flex text-xs-center my-3 justify-center align-center>
                <v-flex xs12>
                  <v-btn class="bebas" small flat outline color="white" @click="e6 = 3">Got it</v-btn>
                </v-flex>
              </v-flex>
            </v-stepper-content>

            <v-stepper-step color="red" :complete="e6 > 3" step="3" :editable="e6 > 3">Click Add</v-stepper-step>

            <v-stepper-content step="3">
              <v-flex class="border-radius-5" d-flex text-xs-center>
                <v-flex class="border-radius-5">

                  <v-img :src="athsFull" />
                </v-flex>
              </v-flex>
              <v-flex d-flex text-xs-center my-3 justify-center align-center>
                <v-flex xs12>

                  <v-btn class="bebas" small flat outline color="white" @click="onboardingStep = 3">Got it</v-btn>
                </v-flex>
              </v-flex>
            </v-stepper-content>

          </v-stepper>
        </v-card>
      </v-container>
      <v-container v-else>

        <v-flex d-flex text-xs-center>
          Click Add to get prompted to add this Application to your home screen.
        </v-flex>
        <v-flex xs12 d-flex>
          <v-btn large color="#AE250A" @click.native="athsAction">
            Add <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-container>
    </v-stepper-content>

    <v-stepper-step color="red" :complete="onboardingStep > 3" step="2" :editable="onboardingStep > 3">Open Progressive Web App with Icon</v-stepper-step>

    <v-stepper-content step="3">
      <v-container px-4 pt-2 pb-5>
        <v-card class="mb-4 border-radius-15">
          <v-flex class="border-radius-5" d-flex text-xs-center>
            <v-flex class="border-radius-5">

              <v-img :src="iconView" />
            </v-flex>
          </v-flex>

        </v-card>
        <v-flex d-flex text-xs-start>
          <ol>
            <li>Click Finish Setup</li>
            <li>Close this window</li>
            <li>Open the Application from the icon on your phone and login</li>
          </ol>
        </v-flex>
        <v-flex d-flex text-xs-center>
          <p class="mt-4 prestige">From this point on you open the app from the icon, just like any other native app. You don't have to use the browser</p>
        </v-flex>
      </v-container>
    </v-stepper-content>
    <v-container>
      <v-flex class="bebas" light v-if="onboardingStep === 3" d-flex text-xs-center justify-center align-center mx-3>
        <v-flex xs6 mx-2 class="black--text">

          <v-btn block large class="border-radius-5" color="white black--text" @click="startInstructionsOver">start over</v-btn>
        </v-flex>
        <v-flex xs6 mx-2>

          <v-btn block large class="border-radius-5" color="white black--text" @click="onboardingFinished">finish setup</v-btn>
        </v-flex>
      </v-flex>

    </v-container>
  </v-stepper>

</v-dialog>
</template>

<script>
import athsFull from "@/assets/onboarding/add-min.png";
import shareButtonFull from "@/assets/onboarding/share-min.png";
import shareMenuFull from "@/assets/onboarding/home-min.png";
import iconView from "@/assets/onboarding/homescreen-min.png";

export default {
  name: "onboarding-container",
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      onboardingStep: 2,
      athsFull,
      shareMenuFull,
      shareButtonFull,
      iconView,
      e6: 1,
      e7: 1,
      maxOnboardingStep: 1
    };
  },
  watch: {
    preloadingImages: function(newData, oldData) {
      if (!newData && this.setupFinished) {
        this.onboardingStep = 2;
      }
    },
    setupFinished: function(newData, oldData) {
      if (newData && !this.preloadingImages) {
        this.onboardingStep = 2;
      }
    }
  },
  mounted() {
    //this.athsSetup()
  },
  computed: {
    serviceWorkerActivated() {
      return this.$store.getters.serviceWorkerActivated;
    },
    serviceWorkerAvailable() {
      return this.$store.getters.serviceWorkerAvailable;
    },
    preloadingImages(val) {
      return this.$store.getters.preloadingImages;
    },
    onIphone() {
      return this.$store.getters.isIos;
    },
    setupFinished() {
      return this.$store.getters.setupFinished;
    }
  },
  methods: {
    athsSetup() {
      //console.log("Setting up");
      window.addEventListener("beforeinstallprompt", e => {
        //console.log("BEFORE INSTALL PROMPT");
        e.preventDefault();
        this.deferredPrompt = e;
      });
    },
    onboardingFinished() {
      this.$store.dispatch("setOnboarding", false);
      this.onboardingStep = 4;
      this.$store.dispatch("setDemoRequest", true);
      // window.close();
    },
    athsAction() {
      const prompt = this.$store.getters.deferredPrompt;
      //console.log("IN ATHS", prompt);
      if (prompt) {
        prompt.prompt();
        prompt.userChoice.then(choiceResult => {
          if (choiceResult.outcome === "accepted") {
            //console.log("User accepted the A2HS prompt");
          } else {
            //console.log("User dismissed the A2HS prompt");
          }
        });
        this.onboardingStep = 3;
      } else {
        this.onboardingStep = 3;
      }
    },
    startInstructionsOver() {
      this.onboardingStep = 2;
      this.e6 = 1;
      this.e7 = 1;
    },
    finalATHS() {
      this.e6 = 1;
    }
  }
};
</script>

<style scoped>
#onboarding-dialog-active {
  height: 500px;
}
</style>

    <!-- <v-stepper-step color="red" class="white--text" :complete="onboardingStep > 1" step="1">
      Downloading Murder Mystery Tour from FDI Headquarters
      <small v-if="onboardingStep === 1">Please wait</small>
    </v-stepper-step>

    <v-stepper-content step="1">

      <v-progress-linear color="red" :indeterminate="true"></v-progress-linear>

    </v-stepper-content> -->
